module.exports = __webpack_public_path__ + "media/images/imap_accounts/icon_yahoo_bb-882091215576397f5605c00ab335da77.png";